/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listBondsPrices = /* GraphQL */ `
  query ListBondsPrices {
    listBondsPrices {
      updatedAt
      bondPrices {
        bondId
        bidPrice
        askPrice
        gSpread
        bidGSpread
        yieldAndSpreadBondYield
        bidYield
      }
    }
  }
`;
export const bondSettlementDate = /* GraphQL */ `
  query BondSettlementDate($input: BondSettlementDateInput!) {
    bondSettlementDate(input: $input) {
      settledAt
    }
  }
`;
export const getAccount = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      id
      owners
      users {
        nextToken
      }
      balanceAccounts {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listAccounts = /* GraphQL */ `
  query ListAccounts(
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owners
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAccountHasUser = /* GraphQL */ `
  query GetAccountHasUser($id: ID!) {
    getAccountHasUser(id: $id) {
      id
      accountId
      account {
        id
        owners
        createdAt
        updatedAt
      }
      userId
      user {
        id
        stripeId
        favoriteBonds
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listAccountHasUsers = /* GraphQL */ `
  query ListAccountHasUsers(
    $filter: ModelAccountHasUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccountHasUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountId
        userId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      accounts {
        nextToken
      }
      stripeId
      favoriteBonds
      createdAt
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        stripeId
        favoriteBonds
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getBalanceAccount = /* GraphQL */ `
  query GetBalanceAccount($id: ID!) {
    getBalanceAccount(id: $id) {
      id
      accountId
      account {
        id
        owners
        createdAt
        updatedAt
      }
      currency
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      transactions {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listBalanceAccounts = /* GraphQL */ `
  query ListBalanceAccounts(
    $filter: ModelBalanceAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBalanceAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountId
        currency
        bondId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTransaction = /* GraphQL */ `
  query GetTransaction($id: ID!) {
    getTransaction(id: $id) {
      id
      accountId
      previousTransactionId
      order
      transactedAt
      balanceAccountId
      balanceAccount {
        id
        accountId
        currency
        bondId
        createdAt
        updatedAt
      }
      source
      type
      amountChange
      disponibleAmountChange
      orderTicketId
      orderTicket {
        id
        accountId
        direction
        balanceAccountId
        bondId
        faceAmount
        bondPrice
        minimumFillSize
        status
        statusLastChangeByUserId
        cancelReason
        isConfirmed
        confirmedByTraderId
        confirmedAt
        closingTradeTicketId
        loadedYield
        isImmediate
        timeInForce
        expiresAt
        createdAt
        updatedAt
      }
      tradeTicketId
      tradeTicket {
        id
        accountId
        orderTicketId
        amount
        bondPrice
        accruedDays
        accruedInterest
        tradeDate
        settlementDate
        isClosed
        finalCommissionAmount
        loadedYield
        createdAt
        updatedAt
      }
      complementaryTransactionId
      balance
      disponibleBalance
      createdAt
      updatedAt
    }
  }
`;
export const listTransactions = /* GraphQL */ `
  query ListTransactions(
    $filter: ModelTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountId
        previousTransactionId
        order
        transactedAt
        balanceAccountId
        source
        type
        amountChange
        disponibleAmountChange
        orderTicketId
        tradeTicketId
        complementaryTransactionId
        balance
        disponibleBalance
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTradeTicket = /* GraphQL */ `
  query GetTradeTicket($id: ID!) {
    getTradeTicket(id: $id) {
      id
      accountId
      orderTicketId
      orderTicket {
        id
        accountId
        direction
        balanceAccountId
        bondId
        faceAmount
        bondPrice
        minimumFillSize
        status
        statusLastChangeByUserId
        cancelReason
        isConfirmed
        confirmedByTraderId
        confirmedAt
        closingTradeTicketId
        loadedYield
        isImmediate
        timeInForce
        expiresAt
        createdAt
        updatedAt
      }
      amount
      bondPrice
      accruedDays
      accruedInterest
      tradeDate
      settlementDate
      closingOrderTickets {
        nextToken
      }
      isClosed
      finalCommissionAmount
      loadedYield
      createdAt
      updatedAt
    }
  }
`;
export const listTradeTickets = /* GraphQL */ `
  query ListTradeTickets(
    $filter: ModelTradeTicketFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTradeTickets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountId
        orderTicketId
        amount
        bondPrice
        accruedDays
        accruedInterest
        tradeDate
        settlementDate
        isClosed
        finalCommissionAmount
        loadedYield
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOrderTicket = /* GraphQL */ `
  query GetOrderTicket($id: ID!) {
    getOrderTicket(id: $id) {
      id
      accountId
      direction
      balanceAccountId
      balanceAccount {
        id
        accountId
        currency
        bondId
        createdAt
        updatedAt
      }
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      faceAmount
      bondPrice
      minimumFillSize
      status
      statusLastChangeByUserId
      cancelReason
      isConfirmed
      confirmedByTraderId
      confirmedAt
      closingTradeTicketId
      tradeTickets {
        nextToken
      }
      appliedCommissionRate {
        amount
        rate
      }
      loadedYield
      isImmediate
      timeInForce
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const listOrderTickets = /* GraphQL */ `
  query ListOrderTickets(
    $filter: ModelOrderTicketFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderTickets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountId
        direction
        balanceAccountId
        bondId
        faceAmount
        bondPrice
        minimumFillSize
        status
        statusLastChangeByUserId
        cancelReason
        isConfirmed
        confirmedByTraderId
        confirmedAt
        closingTradeTicketId
        loadedYield
        isImmediate
        timeInForce
        expiresAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getRateCommission = /* GraphQL */ `
  query GetRateCommission($id: ID!) {
    getRateCommission(id: $id) {
      id
      currency
      amount
      rate
      createdAt
      updatedAt
    }
  }
`;
export const listRateCommissions = /* GraphQL */ `
  query ListRateCommissions(
    $filter: ModelRateCommissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRateCommissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        currency
        amount
        rate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getBond = /* GraphQL */ `
  query GetBond($id: ID!) {
    getBond(id: $id) {
      id
      cusip
      isin
      currency
      issuerId
      issuer {
        id
        name
        ticker
        createdAt
        updatedAt
      }
      couponPayment
      outstandingAmount
      minimumPiece
      minimumIncrement
      isSecRegisteredSecurity
      ratings {
        nextToken
      }
      callDates {
        price
        callDate
      }
      paymentRank
      couponType
      maturity {
        date
        maturityType
        nextCallDate
        nextCallPrice
      }
      bidAmount
      offerAmount
      benchmark
      spreadToBenchmark
      accruedDays
      accruedInterest
      timezone
      interpolatedCDRate
      industry
      esgScore
      couponFrequency
      makeWholeCall
      createdAt
      updatedAt
    }
  }
`;
export const listBonds = /* GraphQL */ `
  query ListBonds(
    $filter: ModelBondFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBonds(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getIssuer = /* GraphQL */ `
  query GetIssuer($id: ID!) {
    getIssuer(id: $id) {
      id
      name
      ticker
      bonds {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listIssuers = /* GraphQL */ `
  query ListIssuers(
    $filter: ModelIssuerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIssuers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        ticker
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getBondRating = /* GraphQL */ `
  query GetBondRating($id: ID!) {
    getBondRating(id: $id) {
      id
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      ratingId
      rating {
        id
        value
        order
        agencyId
        createdAt
        updatedAt
      }
      watch
      createdAt
      updatedAt
    }
  }
`;
export const listBondRatings = /* GraphQL */ `
  query ListBondRatings(
    $filter: ModelBondRatingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBondRatings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        bondId
        ratingId
        watch
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getRating = /* GraphQL */ `
  query GetRating($id: ID!) {
    getRating(id: $id) {
      id
      value
      order
      agencyId
      agency {
        id
        name
        createdAt
        updatedAt
      }
      bondRatings {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listRatings = /* GraphQL */ `
  query ListRatings(
    $filter: ModelRatingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRatings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        value
        order
        agencyId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getRatingAgency = /* GraphQL */ `
  query GetRatingAgency($id: ID!) {
    getRatingAgency(id: $id) {
      id
      name
      ratings {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listRatingAgencys = /* GraphQL */ `
  query ListRatingAgencys(
    $filter: ModelRatingAgencyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRatingAgencys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listTransactionsByBalanceAccountSortedByOrder = /* GraphQL */ `
  query ListTransactionsByBalanceAccountSortedByOrder(
    $balanceAccountId: ID
    $order: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactionsByBalanceAccountSortedByOrder(
      balanceAccountId: $balanceAccountId
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountId
        previousTransactionId
        order
        transactedAt
        balanceAccountId
        source
        type
        amountChange
        disponibleAmountChange
        orderTicketId
        tradeTicketId
        complementaryTransactionId
        balance
        disponibleBalance
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
